export default {
    "Language": "Langue",
    "UserName": "Nom d’utilisateur",
    "Email": "E-mail",
    "PassWord": "Mot de passe",
    "Login": "Connexion",
    "SignUp": "S’inscrire",
    "Welcome": "Bienvenue",
    "ForgotPasswrod": "Mot de passe oublié ?",
    "NoAccount": "Je n’ai pas encore de compte. S’inscrire",
    "ServerError": "Erreur système",
    "ReadAgree": "J’ai lu et j’accepte",
    "And": "et",
    "ScanQRCodeDownloadAPP": "Veuillez scanner le code QR suivant pour télécharger l’application et créer des comptes",
    "EmailEmpty": "Le compte e-mail ne peut pas être vide",
    "PasswordEmpty": "Le mot de passe ne peut pas être vide",
    "PleaseSelect": "Veuillez sélectionner",
    "Logout": "Déconnexion",
    "CreateCompany": "Créer une entreprise",
    "CompanyName": "Nom de l’entreprise *",
    "Confirm": "Confirmer",
    "Cancel": "Annuler",
    "CompanyNameEmpty": "Le nom de l’entreprise ne peut pas être vide",
    "CreatedSuccessfully": "Créé avec succès",
    "CompanyDashboard": "Tableau de bord de l’entreprise",
    "Sites": "Site",
    "CompanyAdmin": "Administrateur de l’entreprise",
    "PurchaseRecord": "Registre d’achat",
    "MoreDetail": "Plus de détails",
    "CreateSite": "Nouveau Site",
    "Admin": "Administrateurs",
    "AdminAccess": "Gérer les utilisateurs qui ont un accès administrateur à cette société",
    "Licenses": "Licences",
    "PaymentInvioces": "Consultez votre historique de paiement et gérez les incidents de l’entreprise",
    "SiteName": "Nom du site *",
    "SiteAddress": "Adresse *",
    "Add": "Ajouter",
    "Edit": "Modifier",
    "Delete": "Supprimer",
    "DeleteSiteTitle": "Êtes-vous sûr de vouloir supprimer le site ?",
    "NoData": "Pas de données",
    "SiteNameEmpty": "Le nom du site ne peut pas être vide",
    "SiteAddressEmpty": "L’adresse du site ne peut pas être vide",
    "UpdateSuccessfully": "Mise à jour réussie",
    "DeleteSuccessfully": "Supprimer avec succès",
    "AddAdmin": "Ajouter un administrateur",
    "AddCompanyAdmin": "Ajouter un administrateur d’entreprise",
    "RegisteredAccount": "Veuillez entrer dans le compte enregistré",
    "EmailAccount": "Compte e-mail *",
    "AdminCompanyRole": "Rôle d’utilisateur Administrateur de l’entreprise",
    "ManagesSitesAdmins": "Gère tous les sites et les administrateurs de site.",
    "AccessBilling": "Effectue des paiements et a accès aux informations de facturation.",
    "Serach": "Rechercher",
    "UserInfo": "Informations sur l’utilisateur",
    "UserAccount": "Compte Utilisateur",
    "Nickname": "Surnom:",
    "FirstName": "Prénom *",
    "Surname": "Nom",
    "SureDelete": "Êtes-vous sûr de vouloir supprimer ?",
    "NoRecord": "Pas de dossier",
    "AdminName": "Nom de l’administrateur",
    "Account": "Compte",
    "Role": "Rôle",
    "CreateDate": "Date de création",
    "EmailEmpty": "Le compte e-mail ne peut pas être vide",
    "EmailIncorrect": "Le compte e-mail n’existe pas ou est incorrect",
    "FirstNameEmpty": "Le prénom ne peut pas être vide !",
    "SurnameNameEmpty": "Le nom de famille ne peut pas être vide !",
    "Save": "Enregistrer",
    "StartTime": "Heure de début",
    "EndTime": "Fin des Temps",
    "NoPurchaseRecord": "Il n’y a pas de Registre d’Achat !",
    "LicenseName": "Nom de la licence",
    "Quantity": "Quantité",
    "Amount": "montant",
    "StartTimeEmptye": "L’heure de début ne peut pas être vide",
    "EndTimeEmptye": "Le temps de fin ne peut pas être vide",
    "StartTimeLaterEndTime": "L’heure de début ne peut pas être postérieure à l’heure de fin",
    "SiteDashboard": "Tableau de bord du site",
    "Blocks": "Blocs ",
    "Panels": "Appareils",
    "SiteUsers": "Utilisateurs du Site",
    "EventRecords": "Registres d’événements",
    "AssessLog": "Journal d’accès",
    "SiteLicenses": "Licences de site",
    "Payments": "Paiements",
    "MyProfile": "Mon profil",
    "AddBlocks": "Ajouter des blocs",
    "BlocksOnSite": "Blocs sur site",
    "SeeAllPanels": "Voir tous les appareils",
    "AddPanels": "Ajouter des panneaux",
    "AddedDecices": "Appareils ajoutés",
    "Normal": "Normal",
    "NeedConfigration": "Besoin de configuration",
    "CheckFail": "Erreur",
    "Offline": "Hors ligne",
    "SeeAllUsers": "Voir tous les utilisateurs",
    "Users": "Utilisateurs",
    "AddUsers": "Ajouter des utilisateurs",
    "AddedUser": "Utilisateur ajouté",
    "LicensesNormal": "Licences actives",
    "LicensesExpired": "Licences expirées",
    "NotOpened": "Non ouvert",
    "NotAccepted": "Non accepté",
    "BuyLiences": "Acheter des licences",
    "RemainingQuantit": "Quantité restante",
    "BuyMore": "Acheter plus",
    "BlocksName": " Nom du bloc *",
    "BlocksNumber": "Numéro du bloc *",
    "DeleteBlock": "Supprimer le bloc",
    "CreateBlock": " Créer un nouveau bloc ",
    "NoBlock": "Aucun bloc existant, veuillez prioriser l'ajout de blocs !",
    "PanelsQuantity": "Quantité de panneaux",
    "UsersQuantity": "Quantité d'utilisateurs",
    "CreateSites": "Créer de nouveaux sites",
    "BlocksNameEmpty": "Le nom des blocs ne peut pas être vide",
    "BlocksNumberEmpty": "Le numéro des blocs ne peut pas être vide",
    "BlockDetail": "Détail du bloc",
    "DeletePanel": "Êtes-vous sûr de vouloir retirer l'appareil du campus ? Après la suppression, il disparaîtra automatiquement du compte utilisateur concerné.",
    "NoPanel": "Aucune information, veuillez prioriser l'ajout d'appareils !",
    "PanelsId": "ID du panneau",
    "PanelsName": "Nom du panneau",
    "PanelsStatus": "Statut du panneau",
    "DeleteUser": "Après la suppression des données, l'utilisateur (et le partage) sera dissocié et ne pourra plus utiliser le service d'entrée du parc ; L'opération de suppression ne pourra pas être restaurée.",
    "NoUser": "Aucune information utilisateur, veuillez ajouter un utilisateur.",
    "HouseNumber": "Numéro d'appartement",
    "UserRole": "Rôle utilisateur",
    "UserStatus": "Statut utilisateur",
    "ServiceStatus": "Statut de la licence",
    "ServicesRemaining": "Durée restante",
    "BlocksDetail": "Détail des blocs",
    "Invalid": "Invalide",
    "Ready": "En ligne",
    "NeedVerification": "Besoin de vérification",
    "NotResponding": "Ne répond pas",
    "Accepted": "Accepté",
    "Refuse": "Refusé",
    "NotBound": "Non lié",
    "NotEnabled": "Non activé",
    "InUse": "En cours d'utilisation",
    "End": "Terminé",
    "Days": "Jours",
    "CreatePanels": "Créer un nouveau panneau",
    "PanelsSerialNumber": "Numéro de série du panneau *",
    "NotFndSerial": "Si vous ne trouvez pas le numéro de série, veuillez cliquer ici",
    "PanelsSecurityCode": "Code de sécurité du panneau *",
    "PanelsSerialCode": "Si vous ne trouvez pas le code de sécurité, veuillez cliquer ici",
    "Or": "Ou",
    "RolePermission": "Contrôle des autorisations de rôle",
    "SiteUser": "Utilisateur du site",
    "SiteEmployee": "Employé du site",
    "SiteOther": "Autre site",
    "Status": "Statut",
    "PanelsSerialNumberEmpty": "Le numéro de série du panneau ne peut pas être vide",
    "PanelsSecurityNumberEmpty": "Le code de sécurité du panneau ne peut pas être vide",
    "PanelsNameEmpty": "Le nom du panneau ne peut pas être vide",
    "SiteOrBlocksEmpty": "Le site ou les blocs ne peuvent pas être vides",
    "AddSuccessful": "Ajout réussi",
    "RevalidateDevice": "Revalider l'appareil",
    "PanelsDetail": "Détail des panneaux",
    "AccessControl": "Contrôle d'accès",
    "DevicesMode": "Mode des appareils",
    "SerialNumber": "Numéro de série",
    "FirmwareVersion": "Version du firmware",
    "Revalidate": "Revalider",
    "UpdateFailure": "Échec de la mise à jour",
    "AddSiteUser": "Ajouter un utilisateur au site",
    "AddingUser": "Ajout de l'utilisateur, veuillez patienter...",
    "UserEmail": "Email de l'utilisateur",
    "ActivationMethod": "Méthode d'activation",
    "ChooseActivationMethod": "Choisissez comment activer le service pour l'utilisateur.",
    "AvailableActivationCodes": "Codes d'activation disponibles",
    "AddUserSuccess": "Ajout de l'utilisateur réussi !",
    "UserHasJoined": "L'utilisateur a rejoint",
    "UserServiceActivated": "Le service de l'utilisateur est activé !",
    "ActivationCode": "Code d'activation",
    "UserConfrmation": "Confirmation de l'utilisateur",
    "ConfirmationEmail": "Un email de confirmation a été envoyé à l'utilisateur, veuillez l'informer de compléter l'opération de suivi selon les instructions contenues dans l'email.",
    "ScanQRCode": "Ou veuillez scanner le code QR avec l'application pour rejoindre !",
    "ServiceActivation": "Activation du service",
    "Total": "Total",
    "Select": "Sélectionner",
    "Activation": "Activation",
    "UserServiceActivation": "Activation du service utilisateur, veuillez patienter...",
    "ConsumedActivate": "Des fiches seront consommées pour activer les utilisateurs suivants",
    "BindingUser": "Utilisateur en cours de liaison",
    "BindingUserWait": "Liaison de l'utilisateur, veuillez patienter...",
    "UnbindingUser": "Utilisateur en cours de dissociation",
    "UnbindingUserDesc": "Après la dissociation, l'utilisateur ne pourra plus utiliser le service de la machine d'entrée du site.",
    "ActivationTypeOne": "Les utilisateurs achètent et activent eux-mêmes",
    "ActivationTypeTwo": "Attribuer un code d'activation",
    "ActivationTypeThree": "Saisir le code d'activation",
    "Years": "Années",
    "Year": "Année",
    "Months": "Mois",
    "Month": "Mois",
    "Day": "Jour",
    "UserEmailEmpty": "L'email de l'utilisateur ne peut pas être vide",
    "HouseNumberEmpty": "Le numéro d'appartement ne peut pas être vide",
    "UserRoleEmpty": "Le rôle utilisateur ne peut pas être vide",
    "ActivationMethodEmpty": "La méthode d'activation ne peut pas être vide",
    "SelectAtLeastOne": "Veuillez sélectionner au moins un critère pour rechercher",
    "SelectAtLeastActivate": "Veuillez sélectionner au moins un utilisateur à activer",
    "SelectLicense": "Veuillez sélectionner une licence",
    "InsufficientLicense": "Quantité de licences insuffisante",
    "ActivationSuccessful": "Activation réussie",
    "BindingSuccessful": "Liaison réussie",
    "UnbindSuccessful": "Dissociation réussie",
    "UserDetail": "Détails de l'utilisateur",
    "Devices": "Appareils",
    "UserSetting": "Paramètres utilisateur",
    "Augment": "Augmenter",
    "DeviceName": "Nom de l'appareil",
    "DeviceId": "ID de l'appareil",
    "AccessRights": "Droits d'accès",
    "AssessStatus": "Statut d'accès",
    "SiteDevices": "Appareils du site",
    "Preview": "Aperçu",
    "PreviewEnd": "Aperçu,",
    "Unlock": "Déverrouiller",
    "UnlockEnd": "Déverrouiller,",
    "Call": "Appeler",
    "CallEnd": "Appeler,",
    "NoAssessLog": "Aucun journal d'accès n'est enregistré !",
    "OperationModule": "Module d'opération",
    "OperationContent": "Contenu de l'opération",
    "Company": "Entreprise",
    "UpdateSite": "Mettre à jour le site",
    "DeleteSite": "Supprimer le site",
    "UpdateBlock": "Mettre à jour le bloc",
    "DeleteBlock": "Supprimer le bloc",
    "BindingPanels": "Lier des panneaux",
    "UpdatePanels": "Mettre à jour les panneaux",
    "UnbindingPanels": "Dissocier les panneaux",
    "UpdateUser": "Mettre à jour l'utilisateur",
    "DeleteUserLog": "Supprimer l'utilisateur",
    "PurchasingLicence": "Achat de licence",
    "UpdateCompanyAdmin": "Mettre à jour l'administrateur de l'entreprise",
    "DeleteCompanyAdmin": "Supprimer l'administrateur de l'entreprise",
    "UserLogin": "Connexion utilisateur",
    "RocessingPayment": "Traitement des données de paiement, veuillez patienter...",
    "PaySuccess": "Paiement réussi",
    "PayFail": "Échec du paiement",
    "Person": "Appartement",
    "BuyQuantity": "Quantité achetée",
    "CustomQuantity": "Quantité personnalisée",
    "PayPlatfrom": "Plateforme de paiement",
    "PayAmount": "Montant du paiement",
    "Pay": "Payer",
    "ServiceLicenses": "Licences de service",
    "ActivationRecords": "Historique d'activation",
    "NoLicense": "Aucune licence disponible, veuillez acheter !",
    "LicensesName": "Nom des licences",
    "ActivationKey": "Code",
    "SelectLicensePurchase": "Veuillez sélectionner la licence que vous souhaitez acheter",
    "PaymentFailure": "Échec du paiement de la commande",
    "BuyNow": "Acheter maintenant",
    "OrderNo": "Numéro de commande",
    "OrderStatus": "Statut de la commande",
    "Date": "Date",
    "OrderName": "Nom de la commande",
    "OrderTime": "Heure de la commande",
    "PayTime": "Heure de paiement",
    "Pending": "En attente",
    "Completed": "Terminé",
    "Expired": "Expiré",
    "UseAPPScanQRCode": "Utilisez l'application QvHome pour scanner le code et utiliser le service",
    "RequestParameterError": "Erreur de paramètre de requête",
    "InvalidRequest": "Requête invalide",
    "RequestTimeou": "Délai d'attente de la requête",
    "UserNoLogin": "Utilisateur non connecté",
    "RemoteServiceNotFound": "Service distant introuvable",
    "ErrorCallingRemoteService": "Erreur lors de l'appel du service distant",
    "DataNotFound": "Données non trouvées",
    "RequestsTooFrequent": "Les requêtes sont trop fréquentes",
    "NoOperationPermission": "Aucune autorisation d'opération",
    "DataAlreadyExists": "Les données existent déjà",
    "UserNamePassword": "Le nom d'utilisateur et le mot de passe ne correspondent pas",
    "AccountAlreadyExists": "Le compte existe déjà",
    "VerificationCodeError": "Erreur de code de vérification",
    "UnknownError": "Erreur inconnue",
    "NoAuthorizedCompany": "Aucune entreprise autorisée trouvée",
    "NoAuthorizedSite": "Aucun site autorisé trouvé",
    "UserNotJoinHouse": "L'utilisateur n'a pas rejoint la maison",
    "CloudPushNotEnabled": "Le service de notification cloud n'est pas activé",
    "DeviceBound": "Appareil lié",
    "HouseNumberAlreadyExists": "Le numéro d'appartement existe déjà",
    "HouseNumberNotExists": "Le numéro d'appartement n'existe pas",
    "BlockNumberNotExists": "Le numéro de tour n'existe pas",
    "DeviceUnbound": "Appareil dissocié",
    "InventoryShortag": "Rupture de stock",
    "PaymentOrderVerificationFailed": "Échec de la vérification de la commande de paiement",
    "PaymentFailed": "Échec du paiement",
    "NoPackageFound": "Aucune commande d'ouverture de forfait trouvée",
    "NoAvailablePackages": "Aucun forfait disponible trouvé",
    "PackageHasModified": "Le forfait a été modifié",
    "ChangedOnce": "Le forfait ne peut être modifié qu'une seule fois dans les 7 jours",
    "OrdersNonRefundable": "Les commandes ne sont pas remboursables",
    "PaymentConfigurationNotFound": "Configuration de paiement introuvable",
    "OrderRefundFailed": "Échec du remboursement de la commande",
    "PackageLessThanOneDay": "Il reste moins d'un jour dans le forfait",
    "DataSaveError": "Erreur d'enregistrement des données",
    "DataUpdateError": "Erreur de mise à jour des données",
    "DataDeleteError": "Erreur de suppression des données",
    "CompanyAdminExistsSite": "L'administrateur de l'entreprise existe déjà sur le site",
    "NotAllowDeleteOurself": "Suppression de soi-même non autorisée",
    "ProductNotSupportBind": "Ce produit ne prend pas en charge l'association",
    "DeviceSecurityCheckFail": "Échec de la vérification du code de sécurité de l'appareil",
    "DeviceNotSupportServer": "L'appareil ne prend pas en charge ce service",
    "OemConfigNotFount": "Configuration OEM non trouvée",
    "EmailSendFail": "Échec de l'envoi de l'e-mail",
    "UserAccountNotFound": "Compte utilisateur non trouvé",
    "CompanyDataNotFond": "Données de l'entreprise non trouvées",
    "DevicesDataNotFond": "Données de l'appareil non trouvées",
    "DevicesNoPermission": "L'appareil n'a pas d'autorisation",
    "UserNotBindingHouse": "L'utilisateur n'a pas de maison liée",
    "PkgNotAvailable": "Forfait indisponible",
    "UserNotFond": "Utilisateur non trouvé",
    "AuthNotFound": "Authentification non trouvée",
    "IotUnlockFail": "Échec du déverrouillage",
    "UserMismatchOem": "L'utilisateur OEM ne correspond pas",
    "AlarmCancelShareFail": "Échec de l'annulation du partage de l'alarme",
    "AlarmUnbindFail": "Échec de la dissociation de l'alarme",
    "AlarmShareFail": "Échec du partage de l'alarme",
    "InvitationInvalid": "Invitation invalide",
    "UnallocatedLicense": "Licence non attribuée",
    "HaveBeenUsed": "Déjà utilisé",
    "CompanyNameLimit": "Le nom de l'entreprise doit contenir entre 1 et 30 caractères",
    "SiteNotFound": "Site non trouvé",
    "SiteNameLimit": "Le nom du site doit contenir entre 1 et 30 caractères",
    "EmailFormatLimit": "Le format de l'e-mail est incorrect",
    "FirstNameLimit": "Le prénom doit contenir entre 1 et 20 caractères",
    "SurnameLimit": "Le nom de famille doit contenir entre 1 et 20 caractères",
    "PersonalInfo": "Informations personnelles",
    "BlockNameLimit": "Le nom du bloc doit contenir entre 1 et 30 caractères",
    "BlockNumberLimit": "Le numéro du bloc doit contenir entre 1 et 30 caractères",
    "DeviceSerialLimit": "Le numéro de série du panneau doit contenir entre 1 et 20 caractères",
    "DeviceSecurityCodeLimit": "Le code de sécurité du panneau doit contenir entre 1 et 64 caractères",
    "DeviceNameLimit": "Le nom du panneau doit contenir entre 1 et 30 caractères",
    "HouseNumberLimit": "Le numéro de l'appartement doit contenir entre 1 et 20 caractères",
    "LoginExpired": "Session expirée, veuillez vous reconnecter",
    "ServicesRemainingLimit": "La valeur des jours de service restants ne peut être que 0 ou un entier positif de 8 chiffres maximum",
    "LastAdminNotDelete": "Le dernier administrateur ne peut pas être supprimé",
    "CanNotUpdateOwnRoles": "Vous ne pouvez pas mettre à jour votre rôle d'administrateur",
    "UserUnbindingFailed": "Échec de la dissociation de l'utilisateur",
    "AdminAccountLimit": "Les comptes administrateurs doivent contenir entre 1 et 100 caractères",
    "UserNameLimit": "Le nom d'utilisateur doit contenir entre 1 et 30 caractères",
    "OrderNoLimit": "Le numéro de commande doit contenir entre 1 et 64 caractères",
    "licensesNumLimit": "Seuls les entiers positifs entre 1 et 999 peuvent être saisis",
    "BlockNumberNotZero": "Le numéro du bloc ne peut pas être 0",
    "CompanyOverLimit": "Le nombre d'entreprises créées dépasse la limite",
    "SiteOverLimit": "Le nombre de sites créés dépasse la limite",
    "ApartmentOverLimit": "Le nombre d'appartements créés dépasse la limite",
    "Notice": "Notifications",
    "PanelLog": "Journal du panneau",
    "OperationLog": "Journal des opérations",
    "Panel": "Panneau",
    "CallHasBeenAnswered": "L'appel a été répondu",
    "CallNotAnswered": "Appel non répondu",
    "Time": "Temps",
    "Default": "Par défaut",
    "QRCodeUnlock": "Déverrouillage par code QR",
    "PasswordUnlock": "Mot de passe de déverrouillage",
    "IndoorMachineUnlock": "Déverrouillage de la machine intérieure",
    "AppUnlock": "Déverrouillage par application",
    "RfCard": "Carte RF",
    "ExitButton": "Bouton de sortie de déverrouillage",
    "DtmfUnlock": "Déverrouillage DTMF",
    "GoogleUnlock": "Déverrouillage Google",
    "AlexaUnlock": "Déverrouillage Alexa",
    "FaceUnlock": "Déverrouillage facial",
    "Success": "Succès",
    "Failed": "Échec",
    "Loading": "Chargement",
    "ApartmentNumber": "Numéro d'appartement",
    "Image": "Image",
    "CallLog": "Journal des appels",
    "AccessLog": "Journal d'accès",
    "Export": "Exporter",
    "UnlockType": "Type de déverrouillage",
    "NoExportData": "Aucune donnée à exporter !",
    "ExportSuccess": "Exportation réussie",
    "Return": "Retour",
    "APPNotice": "Notification d'application",
    "DeviceNotice": "Notification d'appareil",
    "Refresh": "Rafraîchir",
    "AddNotice": "Ajouter une notification",
    "Withdraw": "Retirer",
    "Release": "Publier",
    "More": "Plus",
    "Broadcast": "Diffuser",
    "ChooseDevice": "Choisir un appareil",
    "ReceptionDevice": "Appareil de réception :",
    "SelectedDeviceNumber": "Numéro de l'appareil sélectionné :",
    "Title": "Titre :",
    "DigitsLimit": "La longueur du titre doit être entre 1 et 50 chiffres",
    "TitlePicture": "Image du titre :",
    "PictureRatio": "Remarque : Nous recommandons de télécharger une image avec un ratio de 9:16",
    "TimeRange": "Plage horaire：",
    "CreateNotice": "Créer un avis",
    "Update": "Mettre à jour",
    "Modify": "Modifier",
    "Content": "Contenu",
    "ReleaseStatus": "Statut de publication",
    "Released": "Publié",
    "TitleTable": "Titre",
    "Draft": "Brouillon",
    "TitlePictureEmpty": "Veuillez ajouter l'image de titre",
    "DeleteFailed": "Échec de la suppression",
    "ImageUploadFailed": "Échec du téléchargement de l'image",
    "PleaseSelectDevice": "Veuillez sélectionner un appareil",
    "MaximumDevicesSelected": "Un maximum de 10 appareils peut être sélectionné",
    "SuccessfulWithdraw": "Retrait réussi",
    "SuccessfulRelease": "Publication réussie",
    "RemoveDeviceNotice": "Supprimer l'avis de l'appareil",
    "WithdrawDeviceNotice": "Retirer l'avis de l'appareil",
    "ReleaseDeviceNotice": "Publier l'avis de l'appareil",
    "UpdateNotice": "Mettre à jour l'avis",
    "UploadImagejpg": "Veuillez télécharger une image avec l'extension .jpg !",
    "ConfirmPassword": "Confirmer le mot de passe",
    "Prompt": "Invite",
    "AutoJumpLogin": "Vous serez automatiquement redirigé vers la page de connexion après 0 secondes. Cliquez sur Confirmer pour y accéder immédiatement.",
    "RegisteredSuccess": "Enregistrement réussi",
    "PasswordChangedSuccess": "Mot de passe changé avec succès",
    "SendVerificationCode": "Envoyer le code de vérification",
    "ResendSeconds": "Renvoyer dans 0 secondes",
    "VerificationCode": "Code de vérification",
    "PasswordFormatLimit": "Le mot de passe doit contenir entre 8 et 16 caractères, incluant des lettres majuscules et minuscules, des chiffres et des caractères spéciaux.",
    "ChangePassword": "Changer le mot de passe",
    "NextStep": "Suivant",
    "EnterVerificationCode": "Veuillez entrer le code de vérification",
    "EnterCorrectEmailFormat": "Veuillez entrer un format d'e-mail correct",
    "PasswordLess": "Le mot de passe doit contenir au moins 8 caractères",
    "PasswordLarger": "Le mot de passe ne doit pas dépasser 16 caractères",
    "PasswordNotRules": "Le mot de passe ne respecte pas les règles",
    "EntePasswordAgain": "Veuillez entrer à nouveau le mot de passe",
    "PasswordNotMatch": "Le mot de passe et la confirmation du mot de passe ne correspondent pas",
    "VerificationCodeSentSuccess": "Le code de vérification a été envoyé avec succès",
    "UrlExpired": "L'URL a expiré",
    "EmailAccountExists": "Le compte e-mail existe déjà",
    "VerificationCodeIncorrect": "Le code de vérification est incorrect",
    "VerificationCodeInvalid": "Le code de vérification est invalide",
    "TermsCondition": "Conditions générales",
    "PrivacyPolicy": "Politique de confidentialité",
    "CheckReadAgree": "Veuillez cocher que vous avez lu et accepté les Conditions générales et la Politique de confidentialité",
    "DisplayName": "Nom d'affichage",
    "AccountSettings": "Paramètres du compte",
    "Remark": "Remarque",
    "Server": "Serveur",
    "Port": "Port",
    "TCPOrUDP": "TCP/UDP",
    "DTMFSetting": "Paramètre DTMF",
    "Lock1": "Serrure1",
    "Lock2": "Serrure2",
    "Talk": "Parler",
    "DisplayNameEmpty": "Le nom d'affichage doit contenir entre 1 et 64 caractères",
    "RemarkEmpty": "La remarque doit contenir entre 1 et 64 caractères",
    "ServerEmpty": "Le serveur doit contenir entre 1 et 64 caractères",
    "PortEmpty": "Le port doit contenir entre 1 et 20 caractères",
    "TCPOrUDPEmpty": "Le TCP/UDP ne peut pas être vide",
    "AccountEmpty": "Le compte doit contenir entre 1 et 64 caractères",
    "Lock1Empty": "La Serrure1 doit contenir entre 1 et 20 caractères",
    "Lock2Empty": "La Serrure2 doit contenir entre 1 et 20 caractères",
    "TalkEmpty": "La fonction Parler doit contenir entre 1 et 20 caractères",
    "NoSip": "Aucune information, veuillez d'abord ajouter un nouveau serveur SIP !",
    "PasswordLimit": "Le mot de passe doit contenir entre 1 et 64 caractères",
    "NoGuard": "Aucune information, veuillez d'abord ajouter un nouveau gardien !",
    "SipSettings": "Paramètres SIP",
    "GuardSettings": "Paramètres du gardien",
    "ConfirmDelSip": "Confirmer la suppression du paramètre SIP ?",
    "GuardNameLimit": "Le nom du gardien doit contenir entre 1 et 20 caractères",
    "AddressEmpty": "L'adresse ne peut pas être vide",
    "GuardName": "Nom du gardien",
    "CreateGuard": "Créer un nouveau gardien",
    "EditGuard": "Modifier le gardien",
    "Address": "Adresse",
    "ConfirmDelGuard": "Confirmer la suppression du gardien ?",
    "AddSipServer": "Ajouter un nouveau serveur SIP",
    "ConfirmUnbindPanel": "Confirmer le déliement du panneau ?",
    "PleaseSelectPanels": "Veuillez sélectionner des panneaux",
    "ServerConfigEmpty": "La configuration du serveur ne peut pas être vide",
    "Mode": "Mode",
    "SeverMode": "Mode serveur",
    "P2PMode": "Mode P2P",
    "ServerConfig": "Configuration du serveur",
    "TargetSip": "SIP cible",
    "P2PConfig": "Configuration P2P",
    "CreateDeviceConfig": "Créer une configuration d'appareil",
    "UpdateDeviceConfig": "Mettre à jour la configuration d'appareil",
    "DeleteDeviceConfig": "Supprimer la configuration d'appareil",
    "CreateUserHouseConfig": "Créer une configuration d'utilisateurs du site",
    "UpdateUserHouseConfig": "Mettre à jour la configuration d'utilisateurs du site",
    "DeleteUserHouseConfig": "Supprimer la configuration d'utilisateurs du site",
    "CreateDeviceGuardConfig": "Créer une configuration de gardien d'appareil",
    "UpdateDeviceGuardConfig": "Mettre à jour la configuration de gardien d'appareil",
    "DeleteDeviceGuardConfig": "Supprimer la configuration de gardien d'appareil",
    "CreateDeviceNotice": "Créer un avis d'appareil",
    "UpdateDeviceNotice": "Mettre à jour l'avis de l'appareil",
    "DeleteDeviceNotice": "Supprimer l'avis de l'appareil",
    "DeviceNoticeRelease": "Publier l'avis de l'appareil",
    "DeviceNoticeWithdraw": "Retirer l'avis de l'appareil",
    "EnterTitle": "Veuillez entrer le titre",
    "Unused": "Non utilisé",
    "ServerName": "Nom du serveur",
    "DeviceDelete": "Suppression de l'appareil",
    "PrivateMessage": "Message privé",
    "Profile": "Profil",
    "EnableProfile": "Activer le profil",
    "DisableProfile": "Désactiver le profil",
    "WhetherEnableProfile": "Le profil est-il activé",
    "WhetherDisableProfile": "Faut-il désactiver le profil",
    "PleaseSelectUser": "Veuillez sélectionner un utilisateur",
    "MaximumUserSelected": "Un maximum de 10 utilisateurs peut être sélectionné",
    "SelectedUserNumber": "Nombre d'utilisateurs sélectionnés：",
    "RemoveAppNotice": "Supprimer l'avis de l'application",
    "WithdrawAppNotice": "Retirer l'avis de l'application",
    "ReleaseAppNotice": "Publier l'avis de l'application",
    "TamperLog": "Journal d'altération",
    "ReleaseType": "Type de publication",
    "ReadNumber": "Nombre de lectures",
    "MaximumCharacterLimit": "Le contenu ne peut contenir qu'un maximum de 1 caractère",
    "MaximumNoticeReachLimit": "Le nombre maximal d'annonces a été atteint",
    "UploadedImageLimit": "La taille de l'image téléchargée ne peut pas dépasser 2 Mo !",
    "ContentCannotEmpty": "Le contenu ne peut pas être vide !",
    "EndTimeGreateCurrentTime": "L'heure de fin doit être supérieure à l'heure actuelle !",
    "AccountNotExist": "Le compte n'existe pas",
    "PasswordError": "Le mot de passe est incorrect",
    "PictureRatioApp": "Remarque : Nous recommandons de télécharger une image avec un ratio de 16:9",
    "Name": "Nom",
    "NameCannotEmpty": "Les noms doivent contenir entre 1 et 64 caractères",
    "CardNumber": "Numéro de carte complet",
    "CardNumberEmpty": "Le numéro de carte complet ne peut pas être vide",
    "UnlockOption": "Option de déverrouillage",
    "UnlockOptionEmpty": "L'option de déverrouillage ne peut pas être vide",
    "Limited": "Limité",
    "LimitedEmpty": "La limite ne peut pas être vide",
    "CardSettings": "Paramètres de la carte",
    "LimitedUse": "Utilisation limitée",
    "ValidityTime": "Temps de validité",
    "PanelSync": "Synchronisation de l'appareil",
    "AddCardNumber": "Ajouter un numéro de carte",
    "NumbeOfUses": "Nombre d'utilisations",
    "Unlinmited": "Illimité",
    "Forever": "Pour toujours",
    "EditCardNumber": "Modifier le numéro de carte",
    "ConfirmDeleteCard": "Confirmer la suppression du paramètre de la carte ?",
    "NotApplied": "Non appliqué",
    "ApplicationComplete": "Application terminée",
    "DataValidationFailed": "Échec de la validation des données",
    "TypesNotSupported": "Types non pris en charge",
    "DeviceLimitedInput": "Entrée limitée de l'appareil",
    "CCTVSettings": "Paramètres CCTV",
    "IPRTSPUrl": "IP/RTSP Url",
    "Stream": "Stream",
    "DeletingCCTV": "Confirmer la suppression de la configuration CCTV ?",
    "MainStream": "Stream principal",
    "SubStream": "Stream secondaire",
    "AddCamera": "Ajouter une caméra",
    "EditCamera": "Modifier la caméra",
    "IPRTSPUrlEmpty": "L'IP/RTSP Url ne peut pas être vide",
    "UsernameEmpty": "Le nom d'utilisateur ne peut pas être vide",
    "StreamEmpty": "Le flux ne peut pas être vide",
    "DeviceVersion": "Version de l'appareil",
    "CardNumberExists": "Le numéro de carte existe déjà",
    "AddCard": "Ajouter une carte",
    "FacilityCodeCardNumber": "Code d'installation & Numéro de carte",
    "PleasePlacePard": "Veuillez placer une carte sur le lecteur",
    "ReaderNotDetected": "Lecteur non détecté, veuillez vérifier l'installation de votre pilote ou la connexion du câble !",
    "DownloadDriver": "Télécharger le pilote",
    "TestDriver": "Tester le pilote",
    "ChooseDriverDownload": "Veuillez choisir le pilote correspondant à votre système PC pour le télécharger",
    "RestartTest": "Redémarrer pour tester",
    "FacilityCode": "Code d'installation",
    "FullCardNumLimit": "Le numéro de carte saisi est invalide. Veuillez le saisir à nouveau",
    "FacilityCodeCardNumberEmpty": "Le code d'installation & le numéro de carte ne peuvent pas être vides",
    "FacilityCodeEmpty": "Le code d'installation doit être numérique et ne peut pas être supérieur à 255",
    "FacilityCardNumberEmpty": "Le numéro de carte doit être un chiffre et ne peut pas être supérieur à 65535",
    "ManualInput": "Saisie manuelle",
    "Reader": "Lecteur",
    "SiteList": "Liste des sites",
    "ManageSelectedSite": "Gérer le site sélectionné",
    "ManageSelectEmpty": "Veuillez sélectionner le site à gérer",
    "AdminAccountExists": "Le compte administrateur existe déjà",
    "CompanyNameOnly": "Nom de l'entreprise",
    "DeleteCompanyLimit": "Veuillez supprimer tous les sites sous l'entreprise avant de supprimer l'entreprise",
    "CompanyList": "Liste des entreprises",
    "Rename": "Renommer",
    "InputNewCompanyName": "Veuillez entrer un nouveau nom d'entreprise",
    "SureDeleteCompany": "Êtes-vous sûr de vouloir supprimer l'entreprise ?",
    "SelectPayPlatform": "Veuillez sélectionner la plateforme de paiement",
    "LimitReached": "La limite a été atteinte",
    "LimitPassword": "La longueur maximale du mot de passe ne peut pas dépasser 64 caractères",
    "LimitUserName": "La longueur maximale d'un nom d'utilisateur ne peut pas dépasser 64 caractères",
    "LimitUnlockNum": "Le nombre maximal de restrictions ne peut pas dépasser 100",
    "LimitHouseNumber": "Les numéros d'appartement ne prennent en charge que les lettres majuscules, minuscules ou les chiffres et doivent être supérieurs à 0 s'ils sont composés uniquement de chiffres",
    "LimitBlockNumber": "Le numéro de bloc doit être numérique et supérieur à 0",
    "CardNumberWrong": "Le numéro de carte est incorrect",
    "UsersReachLimit": "Ajout d'utilisateurs atteint la limite",
    "DeviceReachLimit": "Ajout d'appareils atteint la limite",
    "UserMessages": "Messages des utilisateurs",
    "MessagesPending": "En attente",
    "BeingProcessed": "En cours de traitement",
    "MessagesEnd": "Terminé",
    "EmailOrPhone": "E-mail/Téléphone",
    "ReplyMessage": "Répondre au message",
    "Picture": "Image",
    "Description": "Description",
    "Reply": "Répondre",
    "Denied": "Refusé",
    "Finished": "Terminé",
    "Processing": "Traitement",
    "ReplyContents": "Contenu de la réponse",
    "EnterReplyContents": "Veuillez entrer le contenu de la réponse",
    "Submit": "Soumettre",
    "Back": "Retour",
    "Process": "Traiter",
    "Administrator": "Administrateur",
    "FileExceed": "Un maximum de 2 images peut être téléchargé",
    "ReplyEmpty": "La réponse ne peut pas être vide !",
    "UserMessageStatusUpdate": "Mise à jour réussie du statut du message utilisateur !",
    "UserMessageReply": "Réponse au message utilisateur réussie !",
    "PackUp": "Réduire",
    "DisablePreview": "Désactiver l'aperçu",
    "DisableUnlock": "Désactiver le déverrouillage",
    "DisableCall": "Désactiver l'appel",
    "SubmitLimit": "Un maximum de 5 messages sans réponse peut être soumis",
    "DeviceNotOnline": "L'appareil n'est pas en ligne",
    "UploadImagejpgOrPng": "Veuillez télécharger des images avec l'extension .jpg ou .png !",
    "ProblemType": "Type de problème",
    "Question": "Question",
    "BUG": "BUG",
    "Suggestion": "Suggestion",
    "APPOrPhone": "Application/Téléphone",
    "Others": "Autres",
    "Country": "Pays",
    "Permissions": "Autorisations",
    "PrivateIPC": "IPC Privé",
    "PublicIPC": "IPC Public",
    "PasswordErrorTime": "Le mot de passe est incorrect, le compte sera verrouillé après 1 tentative(s).",
    "AccountLockedTime": "Compte verrouillé, veuillez réessayer dans 1 seconde(s).",
    "UserPasswordUnlock": "Déverrouillage par mot de passe.",
    "AddPasswordUnlock": "Ajouter un mot de passe de déverrouillage.",
    "EditPasswordUnlock": "Modifier le mot de passe de déverrouillage.",
    "ConfirmDeletePassword": "Confirmer la suppression du paramètre de déverrouillage par mot de passe ?.",
    "CarPlateSettings": "Paramètres de plaque d'immatriculation.",
    "AddCarPlate": "Ajouter un numéro de plaque d'immatriculation.",
    "RemakeName": "Renommer",
    "CarPlateNumber": "Numéro d'immatriculation",
    "EditCarPlate": "Modifier le numéro d'immatriculation",
    "ConfirmDeleteCarPlate": "Confirmer la suppression du paramètre de plaque d'immatriculation ?",
    "CardNameExists": "Le nom de la carte existe déjà",
    "AutomaticOpeningTimes": "Heures d'ouverture automatique",
    "LockName": "Nom du verrou",
    "ModeSelection": "Sélection du mode",
    "MomentaryUnlock": "Déverrouillage momentané",
    "HoldOpen": "Maintien ouvert",
    "Sunday": "Dimanche",
    "Monday": "Lundi",
    "Tuesday": "Mardi",
    "Wednesday": "Mercredi",
    "Thursday": "Jeudi",
    "Friday": "Vendredi",
    "Saturday": "Samedi",
    "SundayShort": "Dimanche",
    "MondayShort": "Lun",
    "TuesdayShort": "Mar",
    "WednesdayShort": "Mer",
    "ThursdayShort": "Jeu",
    "FridayShort": "Ven",
    "SaturdayShort": "Sam",
    "EmailNotificationsFrequent": "Les notifications par e-mail sont trop fréquentes.",
    "Plan1": "Plan 1",
    "DaySelection": "Sélection du jour",
    "All": "Tous",
    "Apply": "Appliquer",
    "SelectionTime": "Sélectionner l'heure",
    "DeviceNotSupportConfig": "Cette configuration n'est pas prise en charge par l'appareil.",
    "PleaseDaySelection": " Veuillez sélectionner une date.",
    "PleaseSelectPlan": " Veuillez sélectionner le plan de crochetage. ",
    "ApplicationSuccessful": " Demande acceptée. ",
    "LiftRelaySettings": "Paramètres du relais d'ascenseur",
    "LiftEnable": "Activation de l'ascenseur",
    "RelayQuantity": "Quantité de relais",
    "Relay": "Relais",
    "RelayLimit": " Les numéros de relais ne prennent en charge que les nombres négatifs, les lettres ou les chiffres. ",
    "AccountNickname": "Pseudonyme du compte",
    "RelayQuantityEmpty": "La quantité de relais ne peut pas être vide.",
    "RelayConfigurationEmpty": "La configuration du relais ne peut pas être vide.",
    "RelayLengthLimit": "La longueur du relais doit être comprise entre 1 et 20 caractères.",
    "4GStrength": "Puissance 4G",
    "4GProvider": "Fournisseur 4G",
    "FloorNumber": "Numéro d'étage",
    "FloorNumberLengthLimit": "Le numéro d'étage ne peut contenir que des lettres ou des chiffres et doit comporter entre 1 et 20 caractères.",
    "PleaseConfigLiftRelay": "Veuillez d'abord configurer les paramètres du relais d'ascenseur.",
    "PleaseSelectFloorNumber": "Veuillez sélectionner le numéro d'étage.",
    "APPUnlockPermission": "Rôles de contrôle d'accès dans l'application",
    "CarPlateUnlock": "Déverrouillage par plaque d'immatriculation",
    "QRCodeUnlock": "Déverrouillage par code QR",
    "UnlockPasswordEmpty": "Le mot de passe de déverrouillage ne peut pas être vide.",
    "LockTemplate": "Verrouiller",
    "QRCode": "Code QR",
    "ShareQRCode": "Partagez le code QR de déverrouillage avec vos amis, scannez-le devant l'interphone pour déverrouiller la porte.",
    "DownloadTemplate": "Télécharger",
    "AddQRCodeUnlock": "Ajouter un déverrouillage par code QR",
    "EditQRCodeUnlock": "Modifier le déverrouillage par code QR",
    "ConfirmDeleteQRCode": "Confirmez-vous la suppression du paramètre de déverrouillage par code QR ?",
    "AddFaceUnlock": "Ajouter un déverrouillage par reconnaissance faciale",
    "FaceRecord": "Enregistrement du visage",
    "UnableAccessCamera": "L'appareil photo est inaccessible. Veuillez vérifier si l'appareil photo est correctement connecté et si l'accès à l'appareil photo est autorisé.",
    "FaceModelFailedLoad": "Le modèle de détection faciale n'a pas pu être chargé.",
    "CameraSuccessActivated": "La caméra a été activée avec succès.",
    "PleaseTurnOnCamera": "Veuillez d'abord allumer la caméra.",
    "FaceDetectionModelNotLoaded": "Le modèle de détection faciale n'a pas encore été entièrement chargé.",
    "PhotoInspectionFailed": "Échec de l'inspection de la photo.",
    "PleaseTakePhotoOrUploadPicture": "Veuillez prendre une photo ou télécharger une image de votre visage.",
    "FaceDetectionFailed": "Échec de la détection faciale.",
    "ValidatingImage": "Validation de l'image.",
    "ImageValiditedSuccessfully": "Image validée avec succès !",
    "ImageValiditedFailed": "Échec de la validation de l'image !",
    "Retry": "Réessayer.",
    "UnlockQRCode": "Déverrouiller le code QR.",
    "ClickToDisplay": "Cliquer pour afficher.",
    "ClickToCapture": "Cliquer pour capturer.",
    "ConfirmDeleteFaceUnlockSetting": "Confirmer la suppression du paramètre de déverrouillage par reconnaissance faciale ?.",
    "UnlockFace": "Déverrouiller le visage.",
    "ShareManagement": " Gestion du partage ",
    "ShareAccount": "Compte de partage",
    "Alias": "Partagé avec",
    "WantToShare": "Veuillez saisir le compte avec lequel vous souhaitez partager.",
    "ScanQRCodeFriend": "Demandez à vos amis de scanner le code QR ci-dessous avec l'application AES Opyn et d'accéder à l'appareil partagé.",
    "Link": "Lien.",
    "FriendsFamily": "Vos amis et votre famille ne sont pas avec vous ? Essayez avec",
    "ShareLink": "Partager le lien",
    "AccountNnumberEmpty": "Le numéro de compte ne peut pas être vide !",
    "ShareSuccess": "Partage réussi",
    "PendingAcceptance": "En attente",
    "Ignored": "Ignoré",
    "Rejected": "Rejeté",
    "SharerHasDeleted": "Le partageur a supprimé le contenu",
    "UserHasShared": "Cet utilisateur a été partagé",
    "CannotSharedOneself": "Ne peut pas être partagé avec soi-même",
    "SendSharingMessage": "Envoyer un message de partage",
    "ConfirmDeleteShare": "Confirmer la suppression du partage ?",
    "NameExists": "Le nom existe déjà.",
    "CardNumberExceedDigits": "La longueur du numéro de carte ne peut pas dépasser 10 chiffres !",
    "ReInvite": "Réinviter",
    "InvitationDetail": "Détails de l'invitation",
    "Resend": "Renvoyer",
    "EmailSendSuccess": "L'e-mail a été envoyé avec succès",
    "DeleteSiteUser": "Êtes-vous sûr de vouloir supprimer l'utilisateur actuel ? La licence associée sera également supprimée !",
    "BatchImportOrExport": "Importation par lots",
    "ImportField": "Importer",
    "ExportField": "Exporter",
    "ExportTip": "Êtes-vous sûr de vouloir exporter le fichier Excel par défaut vers l'ordinateur local pour configuration ?",
    "ImportedSuccess": "Toutes les données ont été importées avec succès !",
    "ImportedNotAllSuccessful": "98 pièces réussies, 2 pièces échouées, veuillez cliquer sur le bouton \"Télécharger\" en bas pour vérifier et réimporter.",
    "DataSync": "Synchronisation des données",
    "UploadFilexls": "Le fichier à télécharger doit avoir l'extension .xlsx ou .xls.",
    "Reverse": "Inverser",
    "PleaseSelectSiteOrBlocks": "Veuillez sélectionner un site ou un bloc",
    "OriginalPrice": "Prix d'origine",
    "ExportImportFieldUser": "Cette fonctionnalité est conçue pour faciliter l'importation des données cibles par les installateurs. Veuillez utiliser la fonction \"Exporter\" avant chaque opération d'importation par lots et lire attentivement les remarques d'utilisation figurant dans le tableau.",
    "ExportImportFieldCard": "Cette fonctionnalité est conçue pour faciliter l'importation des données cibles par les installateurs. Veuillez utiliser la fonction \"Exporter\" avant chaque opération d'importation par lots et lire attentivement les remarques d'utilisation figurant dans le tableau.",
    "PasswordUnlockLimit": "Le mot de passe doit comporter entre 4 et 12 caractères. ",
    "DeviceDataDuplication": "Duplication des données de l'appareil ",
    "CurrentNumberApartmentMax": "Le nombre actuel de partages d'appartements a atteint son maximum. Veuillez supprimer et réessayer. ",
    "ApartmentNumberExist": "Ce code d'appartement est déjà utilisé. Veuillez choisir un autre code. ",
    "AddOnePanelUse": "Veuillez ajouter au moins un panneau sur le site ou dans le bloc avant d'utiliser cette fonction.",
    "GuardMaximumLimit": "Le nombre de gardes a atteint la limite maximale. ",
    "Importing": "Importation...",
    "ParkingCardNumber": "Numéro de carte de stationnement ",
    "ParkingCardNumberLimit": "Le numéro de carte de stationnement doit être un nombre décimal compris entre 1 et 16 777 215 ! ",
    "ParkingCardNumberExists": "Le numéro de carte de stationnement existe déjà.",
    "GeneralSettings": "Paramètres généraux ",
    "RFID": "RFID",
    "CarPlate": "Plaque d'immatriculation ",
    "WiegandInput": "Entrée Wiegand",
    "PlateNumberExists": "Le numéro de plaque d'immatriculation existe déjà. ",
    "PlateNumberEmpty": "Le numéro d'immatriculation doit comporter entre 1 et 64 caractères. ",
    "LimitUnlockNumLimit": "Le nombre limite doit être un nombre compris entre 1 et 999.",
    "ChangeAssessStatusDesc": "Veuillez noter que les informations d'identification de déverrouillage doivent être cochées manuellement à nouveau pour ce panneau. ",
    "ImportPrompt": "Importation",
    "ExportPrompt": "Exportation",
    "CreateNewDevice": "Créer un nouvel appareil",
    "DeviceType": "Type d’appareil",
    "AccessControlTerminal": "Clavier",
    "PleaseSelectDeviceType": "Veuillez sélectionner le type d’appareil",
    "DeviceSerialNumberEmpty": "Le numéro de série de l’appareil ne peut pas être vide",
    "DeviceSecurityNumberEmpty": "Le code de sécurité de l’appareil ne peut pas être vide",
    "DeviceNameEmpty": "Le nom de l’appareil ne peut pas être vide",
    "DeviceNameLimitNew": "Le nom de l’appareil doit contenir entre 1 et 30 caractères",
    "DeviceSerialLimitNew": "Le numéro de série du panneau doit contenir entre 1 et 20 caractères",
    "DeviceSecurityCodeLimitNew": "Le code de sécurité du panneau doit contenir entre 1 et 64 caractères",
    "DeviceSerialNumber": "Numéro de série de l’appareil *",
    "DeviceSecurityCode": "Code de sécurité de l’appareil *",
    "Error": "Erreur",
    "DeviceTypeError": "L’appareil ajouté ne correspond pas au modèle sélectionné. Veuillez utiliser le bon appareil pour l’ajouter !",
    "CreateNewACT": "Créer un nouveau Clavier",
    "BluetoothVersion": "Version Bluetooth",
    "MCUVersion": "Version MCU",
    "BluetoothMac": "Adresse MAC BLE",
    "IPAddress": "Adresse IP",
    "DeviceStatus": "Statut de l’appareil",
    "DeviceLog": "Journal de l’appareil",
    "MasterCode": "Code maître",
    "RelayActivationTime": "Temps d’activation du relais",
    "ButtonBeep": "Bip du bouton",
    "HoldOpen": "Maintien ouvert",
    "ExitButtonUnlockTime": "Temps de déverrouillage du bouton de sortie",
    "ToneVolume": "Volume de la tonalité",
    "TamperAlarm": "Alarme anti-sabotage",
    "ContinuousInputErrorProtection": "Protection contre les erreurs d’entrée continues",
    "TimeZone": "Fuseau horaire",
    "OFF": "ARRÊT",
    "ON": "ACTIVÉ",
    "MaterCodeLimit": "La longueur du mot de passe doit être comprise entre 6 et 12 chiffres.",
    "RelayActivationTimeLimit": "Le temps d’activation du relais doit être un nombre compris entre 1 et 99 et ne peut pas commencer par 0.",
    "UnlockBluetooth": "Déverrouillage Bluetooth",
    "UnlockFingerPrint": "Déverrouillage par empreinte digitale",
    "WiegandUnlock": "Déverrouillage Wiegand",
    "DeviceDetail": "Détails de l’appareil",
    "BindingDevice": "Associer l’appareil",
    "UpdateDevice": "Mettre à jour l’appareil",
    "UnbindingDevice": "Dissocier l’appareil",
    "ConfirmUnbindDevice": "Confirmer la dissociation de l’appareil ?",
}